(function () {
  if (window.BSTBodyzonesInitialized) {
    return;
  }

  window.BSTBodyzonesInitialized = true;

  function getGroupSelector() {
    return '.bodyzones__group, .group';
  }

  function activateZone(root, group) {
    root.querySelectorAll(`${getGroupSelector()}.is-active`).forEach((activeGroup) => {
      activeGroup.classList.remove('is-active');
    });

    group.classList.add('is-active');
  }

  function handleZoneSelection(root, group) {
    const targetLink = root.querySelector('[data-zone-target="' + group.id + '"]');

    if (!targetLink) {
      return;
    }

    activateZone(root, group);

    root.dispatchEvent(
      new CustomEvent('body-zone', {
        bubbles: true,
        detail: {
          linkTo: group.id,
        },
      })
    );

    window.setTimeout(function () {
      group.classList.remove('is-active');
      targetLink.click();
    }, 400);
  }

  function handleClick(event) {
    const group = event.target.closest(getGroupSelector());

    if (!group || !event.currentTarget.contains(group)) {
      return;
    }

    handleZoneSelection(event.currentTarget, group);
  }

  function initBodyzones(root) {
    if (!root || root.dataset.bodyzonesReady === 'true') {
      return;
    }

    root.querySelectorAll('.bodyzones__link[id^="link-"]').forEach((link) => {
      if (link.dataset.zoneTarget) {
        return;
      }

      const linkId = link.getAttribute('id');
      if (!linkId) {
        return;
      }

      link.dataset.zoneTarget = linkId.replace(/^link-/, '');
    });

    root.dataset.bodyzonesReady = 'true';
    root.addEventListener('click', handleClick);
  }

  document
    .querySelectorAll('[data-bst-bodyzones], .bodyzones[data-component*="bodyzones-point"]')
    .forEach(initBodyzones);

  document.addEventListener('shopify:section:load', function (event) {
    event.target
      .querySelectorAll('[data-bst-bodyzones], .bodyzones[data-component*="bodyzones-point"]')
      .forEach(initBodyzones);
  });
})();
